import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
      <path
        d="m18,2.2H6c-2.1,0-3.8,1.7-3.8,3.8v12c0,2.1,1.7,3.8,3.8,3.8h12c2.1,0,3.8-1.7,3.8-3.8V6c0-2.1-1.7-3.8-3.8-3.8Zm-9.2,1.6h6.5v.8c0,.1-.1.2-.2.2h-6.1c-.1,0-.2-.1-.2-.2v-.8Zm11.4,14.2c0,1.2-1,2.2-2.2,2.2H6c-1.2,0-2.2-1-2.2-2.2V6c0-1.2,1-2.2,2.2-2.2h1.2v.8c0,1,.8,1.8,1.8,1.8h6c1,0,1.8-.8,1.8-1.8v-.8h1.2c1.2,0,2.2,1,2.2,2.2v12Z"
        stroke-width="0"
      />
      <path
        d="m13.7,9.4l-4.9,4.8c-.3.3-.5.7-.6,1.1l-.2,1.5c0,.1.1.2.2.2l1.6-.3c.4-.1.7-.3,1-.5l4.9-4.8c.5-.5.5-1.4,0-1.9-.6-.6-1.5-.6-2-.1Z"
        stroke-width="0"
      />
    </svg>
    ),
  },
});
